import { Component, OnInit, HostListener, ViewChild, Input } from '@angular/core';
import { NewsfeedService } from './../_services/newsfeed.service';
import { Store } from '@ngrx/store';
import moment from 'moment-timezone';
import { environment } from '../../environments/environment';
import { MatSelectionList } from '@angular/material';
import { LobbyService } from './../_services/lobby.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmboxComponent } from '../confirmbox/confirmbox.component';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { trigger, transition, animate, style } from '@angular/animations'
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-newsfeed',
  templateUrl: './newsfeed.component.html',
  styleUrls: ['./newsfeed.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(-100%)'}),
        animate('600ms ease-in', style({transform: 'translateX(0%)'}))
      ]),
      transition(':leave', [
         animate('1000ms ease-out', style({transform: 'translateY(-100%)'}))
      ])
    ])
  ]
})

@HostListener('scroll', ['$event'])

export class NewsfeedComponent implements OnInit {
  @Input('pageName') pageName = '';
  @Input('tourId') tourId = 0;
  @Input('lgId') lgId = 0;
  
  filters = null;
  user = null;
  expanded = false;
  posts = [];
  isLoading = true;
  page = 1;
  showPostbox = false;
  postboxPost = null;
  postboxType = 'post';
  feedSearch = '';
  showFeedSearch = false;
  feedSearchTimer = null;
  showLikeList = false;
  likeList = null;
  showFilters = false;
  showSearch = false;
  selectedFeeds = [];
  selectedGames = [];
  gamePriorities = {};
  games = [];
  feeds = [
    { view: 'All', value: 'all' },
    { view: 'Fantasy', value: 'fantasy' },
    { view: 'News', value: 'news' },
    { view: 'Friends', value: 'following' },
    { view: 'Community', value: 'community' }
  ];
  bucketURL = `${environment.assetURL}` + '/assets/default/images/';
  rotowireLogo = `${environment.assetURL}` + '/assets/default/images/rotowire-logo.jpg';
  @ViewChild('filters') filterList: MatSelectionList;
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  isShow = true;
  showFeedCon = true;
  fullWidthLobby = true;
  isMobile:any;
  sub_isMobileScreen: Subscription;
  stopRequest = false;
  
  constructor(public dialog: MatDialog, private _lobbyService: LobbyService, private newsfeedService: NewsfeedService, private store: Store<any>,private deviceService: DeviceDetectorService) {
    this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        if(state[0].isDarkMode)
        this.rotowireLogo = `${environment.assetURL}` + '/assets/default/images/rotowire-logo-dark.png';
        else
        this.rotowireLogo = `${environment.assetURL}` + '/assets/default/images/rotowire-logo.jpg';
      }
    });
    this._lobbyService.getGames().subscribe(state => {
      if (state.status == 'success') {
        state.entities.forEach(game => {
          this.games.push(game);
        });
      }
    });
  }

  ngOnInit() {
    this.store.select('authData').subscribe(state => {
      if (localStorage.getItem('currentUser') == null){
        // redirect to login page
        window.location.href = `${environment.SITE_URL}`+ '/logout';
      }
      if (state[0]) {
        this.user = state[0];
        this.filters = {
          feed_type: this.user.feed_type,
          game_type: this.user.game_type,
          news_priority: this.user.news_priority
        };
        this.selectedFeeds = this.filters.feed_type.split(',');
        this.selectedGames = this.filters.game_type.split(',');
        this.filters.news_priority.split(',').forEach(game => {
          if (game.length) {
            const priority = game.split('|');
            this.gamePriorities[priority[0]] = parseInt(priority[1]);
          }
        });
        this.isMobile = this.deviceService.isMobile();
        if(this.sub_isMobileScreen) { this.sub_isMobileScreen.unsubscribe(); }
        this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
          if (state.length > 0) {
            this.isMobile = state[0];
          }
        });
        this.loadPosts();
      }
    });
  }

  toggleSearchBox() {
    this.isShow = !this.isShow;
  }
  
  getUserImage(post) {
    if (post.feed_type == 'league_news') {
      if (post.game_id != 5) {
        return `${environment.assetURL}` + '/assets/uploads/teams/' + post.image;
      } else {
        return `${environment.assetURL}` + '/assets/uploads/teams/156.png';
      }
    } 
    else {
      let path = (post.picture).split('/');
			if (path.length >=2 && path[path.length - 2] == "preset") {
        return `${environment.assetURL}` + '/assets/default/images/' + path[path.length - 2] + '/' + path[path.length - 1];
			} 
      else if(path[path.length - 1]=='user.png') {
				return `${environment.assetURL}` + '/assets/default/images/user.png';
			} 
      else {
				return `${environment.assetURL}` + '/assets/uploads/users/' + post.user_id + '/profile/image_50x50/' + path[path.length - 1];
			}
    }
  }

  getTimestamp(ts) {
    moment.updateLocale('en', {
      relativeTime: {
        future: 'in %s',
        past: '%s',
        s: '1s',
        ss: '%ds',
        m: '1m',
        mm: '%dm',
        h: '1H',
        hh: '%dH',
        d: '1D',
        dd: '%dD',
        w: '1W',
        ww: '%dW',
        M: '1M',
        MM: '%dM',
        y: '1Y',
        yy: '%dY'
      }
    });
    return moment.unix(ts).fromNow();
  }
  
  unescapePost(post) {
    return post.replace(/\\u[\dA-F]{4}/gi, function(match) {
      return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
    }).replace(/\\/g, '');
  }

  profileLink(drafters_id) {
    return `${environment.SITE_URL}` + '/' + drafters_id + '/profile';
  }

  likePost(post) {
    let like_status = 0;
    if (post.is_like == 'yes') {
      post.is_like = 'no';
      post.like_count--;
    } else {
      post.is_like = 'yes';
      like_status = 1;
      post.like_count++;
    }
    this.newsfeedService.likePost(this.user.id, post.id, post.user_id, like_status, this.user.drafters_id).subscribe(state => {
      // console.log(state);
    });
  }

  likeComment(comment) {
    let like_status = 0;
    if (comment.is_like == 'yes') {
      comment.is_like = 'no';
      comment.like_count--;
    } else {
      comment.is_like = 'yes';
      like_status = 1;
      comment.like_count++;
    }
    this.newsfeedService.likeComment(this.user.id, comment.id, like_status, this.user.drafters_id).subscribe(state => {
      // console.log(state);
    });
  }

  scrollPosts(event) {
    if (event.target.scrollHeight - event.target.scrollTop - event.target.offsetHeight < 200 && !this.isLoading && !this.stopRequest) {
      this.isLoading = true;
      this.loadMorePosts();
    }
  }

  loadPosts(search = null, save = false) {
    this.posts = [];
    this.isLoading = true;
    this.stopRequest = false;
    this.page = 1;
    this.newsfeedService.getPosts(this.user.id, this.filters, this.page, search, save, this.lgId, this.tourId, this.pageName).subscribe(state => {
      this.isLoading = false;
      this.posts = state.entities;
      this.posts.forEach(post => {
        post.expanded = post.is_pin != 'Y'?false:true;
        post.showComments = false;
        post = this.parsePost(post);
        if (post.info != null && post.info != '' && post.info != 'Array') {
          post.info = (post.info).replace("\\'", "'");
          post.info = JSON.parse(post.info);
        }
        post.comments.forEach(comment => {
          comment = this.parsePost(comment, true);
        });
      });
    });
  }

  postLikeList(post_id) {
    this.newsfeedService.postLikeList(post_id).subscribe(state => {
      if (state.status == 'success' && state.entities.length) {
        this.likeList = {
          list: state.entities,
          header: 'Post Likes'
        };
        this.showLikeList = true;
      }
    });
  }

  commentLikeList(comment_id) {
    this.newsfeedService.commentLikeList(comment_id).subscribe(state => {
      if (state.status == 'success' && state.entities.length) {
        this.likeList = {
          list: state.entities,
          header: 'Comment Likes'
        };
        this.showLikeList = true;
      }
    });
  }

  loadMorePosts() {
    this.page++;
    this.newsfeedService.getPosts(this.user.id, this.filters, this.page, '', false, this.lgId, this.tourId, this.pageName).subscribe(state => {
      this.isLoading = false;
      if (state.entities.length) {
        state.entities.forEach(post => {
          post.expanded = false;
          post.showComments = false;
          if (post.info != null && post.info != '' && post.info != 'Array') post.info = JSON.parse(post.info);
          post.comments.forEach(comment => {
            comment = this.parsePost(comment, true);
          });
          this.posts.push(this.parsePost(post));
        });
      }
      else {
        this.stopRequest = true;
      }
    });
  }

  loadMoreComments(post) {
    post.comment_cursor++;
    this.newsfeedService.loadMoreComments(post.id, post.comment_cursor, this.user.id, post.comments_count).subscribe(state => {
      if (state.status == 'success') {
        state.data.forEach(comment => {
          post.comments = [this.parsePost(comment, true), ...post.comments];
        });
      }
    });
  }

  loadNewComments(post) {
    this.newsfeedService.loadMoreComments(post.id, 1, this.user.id, post.comments_count + 1).subscribe(state => {
      if (state.status == 'success') {
        state.data.forEach(comment => {
          if (post.comments.filter(c => c.id == comment.id).length == 0) {
            post.comments.push(this.parsePost(comment, true));
            post.comments_count++;
          }
        });
      }
    });
  }

  postboxClose(event) {
    if (event == 1) {
      this.loadPosts();
    } else if (event == 2) {
      this.loadNewComments(this.postboxPost);
    }
  }

  parsePost(post, isComment = false) {
    if (isComment) {
      post.comment = this.unescapePost(post.comment);
      if (post.comment.indexOf('{GIF') > -1) {
        post.is_gif = true;
        post.gif = post.comment.match(/\{GIF(.*)\}/)[1];
        post.comment = post.comment.replace(/{[^}]*}/,'');
        if (post.comment.trim() == 'null') {
          post.comment = '';
        }
      } else {
        post.is_gif = false;
      }
    } else {
      if (['league_post', 'status_update', 'swap_post'].includes(post.feed_type) && post.detail.indexOf('{GIF') < 0 && post.detail.indexOf('{POLL') < 0) {
        let postContent = this.parseJsonContent(post.content);
        post.detail = this.unescapePost(postContent);
      }
      else {
        post.detail = this.unescapePost(post.detail);
      }
      
      if (post.detail.indexOf('{POLL') > -1) {
        post.is_poll = true;
        post.poll_id = post.detail.match(/\{POLL(.*)\}/)[1];
        post.detail = 'User Poll';
      } else {
        post.is_poll = false;
        post.poll_id = 0;
      }
      if (post.detail.indexOf('{GIF') > -1) {
        post.is_gif = true;
        post.gif = post.detail.match(/\{GIF(.*)\}/)[1];
        post.detail = post.detail.replace(/{[^}]*}/,'');
        if (post.detail.trim() == 'null') {
          post.detail = '';
        }
      } else {
        post.is_gif = false;
      } 
    }
    return post;
  }
  
  parseJsonContent(contentJson) {
    const contentStrings = [];
    if (this.pageName == 'lgProfile') {
      contentJson = JSON.parse(contentJson);
    }
    contentJson.forEach(obj => {
      if (obj.type == 'text') {
        let contentString = (obj.content).replace(new RegExp('\n', 'g'), '<br/>')
        contentStrings.push(contentString);
      }
    });
    return contentStrings.join('<br>');
  }

  searchFeed(event) {
    clearTimeout(this.feedSearchTimer);
    if (event.keyCode == 13) {
      this.loadPosts(this.feedSearch, false);
      this.showFeedSearch = false;
    } else {
      this.feedSearchTimer = setTimeout(() => {
        this.loadPosts(this.feedSearch, false);
      }, 800);
    }
  }
  

  pollLikeList(event) {
    this.newsfeedService.pollLikeList(event.id, event.choice).subscribe(state => {
      if (state.status == 'success' && state.entities.length) {
        this.likeList = {
          list: state.entities,
          header: event.header
        };
        this.showLikeList = true;
      }
    });
  }

  updateFeedFilters(event) {
    if (event.option.value == 'all') {
      // special all behavior
      if (event.option._selected) {
        this.selectedFeeds = ['all'];
      } else {
        this.selectedFeeds = [];
      }
    } else if (this.selectedFeeds.length < this.feeds.length - 1) {
      if (this.selectedFeeds.indexOf('all') > -1) {
        const temp = [];
        this.selectedFeeds.forEach(feed => {
          if (feed != 'all') temp.push(feed);
        });
        this.selectedFeeds = temp;
      }
    } else {
      this.selectedFeeds = ['all'];
    }
    // console.log(this.filters);
  }

  saveFilters() {
    this.filters.feed_type = this.selectedFeeds.join(',');
    this.filters.game_type = this.selectedGames.join(',');
    const temp = [];
    this.games.forEach(game => {
      temp.push(game.name + '|' + this.gamePriorities[game.name]);
    });
    this.filters.news_priority = temp.join(',');
    this.loadPosts(this.feedSearch, true);
    this.showFilters = false;
  }

  resetFilters() {
    this.selectedFeeds = this.filters.feed_type.split(',');
    this.selectedGames = this.filters.game_type.split(',');
    this.filters.news_priority.split(',').forEach(game => {
      if (game.length) {
        const priority = game.split('|');
        this.gamePriorities[priority[0]] = parseInt(priority[1]);
      }
    });
    this.showFilters = false;
  }
  
  confirmDialog(params) {
    this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
      width: '500px',
      data: { 'title' : 'Information', 'body' : params['message'], 'type' : 'confirm_popup' }
    });
     
    this.confirmDialogRef.afterClosed()
    .subscribe(res => {
      if (res) {
        if (params['type'] == 'delete') {
          this.deletePost(params['postId'], params['postIndex']);
        }
        else if (params['type'] == 'hide') {
          this.hidePost(params['postId'], params['postIndex']);
        }
        else if (params['type'] == 'pin') {
          this.pinPost(params['postId'], params['postIndex'], 'N');
        }
        else if (params['type'] == 'unpin') {
          this.pinPost(params['postId'], params['postIndex'], 'Y');
        }
        else if (params['type'] == 'delete-comment') {
          this.deleteComment(params['postIndex'], params['commentId'], params['commentIndex']);
        }
      }
    })
  }
  
  deletePost(post_id, index) {
    this.posts[index].hidden = true;
    this.newsfeedService.deletePost(this.user.id, post_id, this.user.role_id).subscribe(state => {
      if (state.status == 'success') {
        this.posts.splice(index, 1);
      }
      else {
        this.posts[index].hidden = false;
      }
    });
  }
  
  hidePost(post_id, index) {
    this.posts[index].hidden = true;
    this.newsfeedService.hidePost(this.user.id, post_id).subscribe(state => {
      if (state.status == 'success') {
        this.posts.splice(index, 1);
      }
      else {
        this.posts[index].hidden = false;
      }
    });
  }
  
  pinPost(post_id, index, status) {
    this.newsfeedService.pinPost(this.user.role_id, post_id, status).subscribe(state => {
      if (state.status == 'success') {
        if (status == 'N') {
          this.posts[index].is_pin = 'Y';
        }
        else {
          this.posts[index].is_pin = 'N';
        }
      }
    });
  }
  
  deleteComment(post_index, comment_id, comment_index) {
    this.newsfeedService.deleteComment(this.user.id, comment_id, this.user.role_id).subscribe(state => {
      if (state.status == 'success') {
        this.posts[post_index].comments.splice(comment_index, 1);
        var post_comment_count = parseInt(this.posts[post_index].comments_count) - 1;
        this.posts[post_index]['comments_count'] = post_comment_count;
      }
    });
  }
  
  leagueProfileRedirect (info) {
    if (info != null && info != '' && info.lg_code !='') {
      var gameCodes = {1:'nhl', 2:'nfl', 3:'mlb', 4:'nba', 5:'pga'};
      window.location.href = `${environment.SITE_URL}/league/profile/${gameCodes[info.gm_id]}/${info.lg_code}`;
    }
  }
  clickOnFeedContainer(){
    this.showFeedCon = !this.showFeedCon;  
    setTimeout(()=>{
      this.fullWidthLobby = this.showFeedCon;  
    },this.showFeedCon?200:900);  
  }
}